import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard } from 'lucide-react';
import { useLanguage } from '../../assets/js/LanguageContext';
import { SUPPORT_EMAIL } from '../Footer';
import '../../assets/styles/SurveyAnswer.css';
import '../../assets/styles/PaymentResult.css';

// Vuelta de Stripe cuando la persona sale del pago sin completarlo
const CancelPage = () => {
  const { t } = useLanguage();

  return (
    <main className="tp-answer tp-payment">
      <div className="tp-answer__inner tp-answer__inner--center">
        <section className="tp-answer__card tp-answer__state">
          <span className="tp-answer__state-icon" aria-hidden="true">
            <CreditCard size={28} strokeWidth={1.75} />
          </span>
          <h1 className="tp-answer__question">{t('pay_cancel_title')}</h1>
          <p className="tp-answer__hint">{t('pay_cancel_text')}</p>

          <ul className="tp-payment__list">
            <li>{t('pay_cancel_help_1')}</li>
            <li>{t('pay_cancel_help_2')}</li>
          </ul>

          <div className="tp-payment__actions">
            <Link to="/subscribe" className="btn btn--primary">{t('pay_try_again')}</Link>
            <Link to="/dashboard" className="btn btn--outline">{t('pay_go_dashboard')}</Link>
          </div>
          <p className="tp-payment__contact">
            {t('pay_contact')} <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>
        </section>
      </div>
    </main>
  );
};

export default CancelPage;
